import { render, staticRenderFns } from "./DirectImageUploader.vue?vue&type=template&id=88daf69e&scoped=true"
import script from "./DirectImageUploader.vue?vue&type=script&lang=js"
export * from "./DirectImageUploader.vue?vue&type=script&lang=js"
import style0 from "./DirectImageUploader.vue?vue&type=style&index=0&id=88daf69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88daf69e",
  null
  
)

export default component.exports